// Timing option constants for Event Timing tabs

// Warmup time options
export const WARMUP_ADD_OPTIONS = ['0:30', '1:00', '1:30', '2:00'];

// Time per skater options (2:00 to 9:00 in 30s increments)
export const TIME_PER_SKATER_OPTIONS = ['2:00', '2:30', '3:00', '3:30', '4:00', '4:30', '5:00', '5:30', '6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00'];

// Compulsory Dance time options (0:30 to 6:00 in 30s increments)
export const COMPULSORY_DANCE_TIME_OPTIONS = [
  '0:30', '1:00', '1:30', '2:00', '2:30', '3:00', '3:30', '4:00', '4:30', '5:00', '5:30', '6:00'
];

// Teams warmup options (0:00 to 5:00 in 30s increments) - 0:00 = no warmup
export const TEAMS_WARMUP_OPTIONS = [
  '0:00', '0:30', '1:00', '1:30', '2:00', '2:30', '3:00', '3:30', '4:00', '4:30', '5:00'
];

// Teams time per team options (5:00 to 9:00 in 30s increments)
export const TEAMS_TIME_OPTIONS = [
  '5:00', '5:30', '6:00', '6:30', '7:00', '7:30', '8:00', '8:30', '9:00'
];

// Figures warm up base time options (5:00 to 10:00 round minutes)
export const FIGURES_WARMUP_BASE_OPTIONS = ['1:00', '2:00', '3:00', '4:00', '5:00', '6:00', '7:00', '8:00', '9:00', '10:00'];

// Figures warm up add options (none, 1:00 to 3:00 round minutes)
export const FIGURES_WARMUP_ADD_OPTIONS = ['none', '1:00', '2:00', '3:00'];

// Figures time per figure options (1:00 to 4:00 in 30s increments)
export const FIGURES_TIME_PER_FIGURE_OPTIONS = ['1:00', '1:30', '2:00', '2:30', '3:00', '3:30', '4:00'];

// Competition breaks length options (0:00 for markers like End of Day, then 5 min increments from 0:05 to 1:00)
export const BREAK_LENGTH_OPTIONS = [
  '0:00', '0:05', '0:10', '0:15', '0:20', '0:25', '0:30', '0:35', '0:40', '0:45', '0:50', '0:55', '1:00'
];
